import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../components/login/login";
import ForgotPassword from "../components/forgotPassword/ForgotPassword";
import SideBar from "../layouts/sideBar";
import Header from "../layouts/header";
import PageContent from "../layouts/content";
import Dashboard from "../pages/dashboard";
import Health from "../pages/health";
import BayInformation from "../pages/bayInformation";
import Profile from "../pages/profile";
import Device from "../pages/device";
import ProtectedRoutes from "../services/protectedRoutes";
import VehicleEntry from "../pages/vehicleEntry";
import AddDevice from '../pages/addDevice';
import DeviceDetails from '../pages/deviceDetails';
import Shop from '../pages/shop';
import Bay from '../pages/bay';
import Trip from '../pages/trip';
import AddTrip from '../pages/addTrip';
import Vendor from '../pages/vendor';
import "./router.css";
import BayDetails from '../pages/BayDetails';
import TruckBoard from '../pages/TruckBoard';
import VendorDetails from '../pages/vendorDetails';
import Loader from '../components/Loader/Loader';
import Employee from '../pages/employee';
import ViewEmployee from '../pages/viewEmployee';
import ViewShop from '../pages/viewShop';
import ViewTrip from '../pages/viewTrip';
import Vehicle from '../pages/vehicle';
import BayStatusReport from "../pages/BayStatusReport";
import GlobalSocketListener from '../context/GlobalSocketListener';
import VehicleInfo from '../pages/vehicleInfo';
import VehicleParkingExit from '../pages/VehicleParkingExit';
import AddVehicle from '../pages/addVehicle';
const AppRouter = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        setIsAuthenticated(localStorage.getItem('loggedin') === 'true');
    }, []);  // ✅ Runs only on mount

    return (
        <Router>
            {/* <GlobalSocketListener /> */}
            <Routes>
                {!isAuthenticated ? (
                    <>
                        <Route path="/login" element={<Login setIsLoggedIn={setIsAuthenticated} />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="*" element={<Navigate to="/login" />} /> {/* Redirect unknown routes to login */}
                    </>
                ) : (
                    <Route path="*" element={<Navigate to="/" />} />
                )}

                <Route element={<>
                    {/* <GlobalSocketListener /> */}
                    <ProtectedRoutes />
                </>}>
                    <Route path="/" element={
                        <div className="d-flex flex-column flex-md-row">
                            {/* Sidebar - Responsive and collapsible */}
                            <div className={` ${isCollapsed ? "collapsed" : "col-md-2"}`}>
                                <SideBar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                            </div>

                            {/* Main content */}
                            <div className={`content-wrapper flex-grow-1 ${isCollapsed ? "collapsed" : "col-md-10"}`}>
                                <header style={{ position: 'sticky', top: 0, zIndex: "999" }} className={`header text-white d-flex align-items-center justify-content-between px-4 py-4 ${isCollapsed ? "collapsed-header" : ""}`}>

                                    <Header isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                                </header>
                                <main className="content-column  flex-grow-1">
                                    <PageContent />
                                </main>
                            </div>
                        </div>
                    }>
                        <Route path="/" element={<Dashboard />} />

                        <Route path="loader" element={<Loader />} />
                        <Route path="health" element={<Health />} />
                        <Route path="bay-info" element={<BayInformation />} />
                        <Route path="profile" element={<Profile />} />
                        <Route path="device" element={<Device />} />
                        <Route path='addDevice' element={<AddDevice />} />
                        <Route path="device/:id" element={<DeviceDetails />} />
                        <Route path="vehicleEntry" element={<VehicleEntry />} />
                        <Route path='parkingExit' element={<VehicleParkingExit/>}/>
                        <Route path="shop" element={<Shop />} />
                        <Route path='shop/:id' element={<ViewShop />} />
                        <Route path="bay" element={<Bay />} />
                        <Route path='bay/:id' element={<BayDetails />} />
                        
                        <Route path='trip' element={<Trip />} />
                        <Route path="addTrip" element={<AddTrip />} />
                        <Route path='trip/:id' element={<ViewTrip />} />
                        <Route path="vendor" element={<Vendor />} />
                        <Route path='vendor/:id' element={<VendorDetails />} />
                        <Route path="employee" element={<Employee />} />
                        <Route path='employee/:id' element={<ViewEmployee />} />
                        <Route path='/vehicle_schedule' element={<Vehicle />} />
                        <Route path='/vehicle_info' element={<VehicleInfo/>} />
                        <Route path='addVehicle' element={<AddVehicle/>} />
                        <Route path='/report/bay' element={<BayStatusReport />} />
                    </Route>
                </Route>
                <Route path='liveBoard' element={<TruckBoard />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;
